module.exports = __webpack_public_path__ + "img/ob_18.7962b9d0.jpg";